module.exports = __webpack_public_path__ + "img/Right Side Background.78807c0.svg";